import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonPopover } from '@ionic/angular';

const OFFSET_FROM_EL_PX = 4;

@Component({
  selector: 'frontend-tooltip',
  templateUrl: './frontend-tooltip.component.html',
  styleUrls: ['./frontend-tooltip.component.scss'],
  standalone: false,
})
export class FrontTooltipComponent implements AfterViewInit, OnDestroy {
  @ViewChild(IonPopover) popover?: IonPopover;
  @Input() parentId = '';
  @Input() text = '';

  private parentEl: HTMLElement | null = null;
  private tooltipEl: HTMLElement | null = null;

  constructor(private readonly sanitizer: DomSanitizer) {}

  show = (mouse: MouseEvent) => {
    if (!this.tooltipEl || !this.parentEl) {
      return;
    }

    const box = this.parentEl.getBoundingClientRect();

    this.tooltipEl.style.display = 'flex';
    this.tooltipEl.style.left = `${(box.left + (box.width / 2)) - (this.tooltipEl.offsetWidth / 2)}px`;
    this.tooltipEl.style.top = `${box.top + box.height + OFFSET_FROM_EL_PX}px`;
  };

  hide = () => {
    if (!this.tooltipEl) {
      return;
    }

    this.tooltipEl.style.display = 'none';
  };

  ngAfterViewInit() {
    this.parentEl = document.getElementById(this.parentId);
    if (!this.parentEl) {
      return;
    }

    const tooltipEl = document.createElement('div');
    tooltipEl.style.position = 'fixed';
    tooltipEl.style.border = '1px solid';
    tooltipEl.style.borderRadius = '.5rem';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.display = 'none';
    tooltipEl.style.fontSize = '.8rem';
    tooltipEl.style.zIndex = '999999';
    tooltipEl.style.padding = '.25rem';
    tooltipEl.style.boxShadow = '0 14px 24px rgba(0, 0, 0, 0.4)';
    tooltipEl.classList.add('background-background', 'border-border');
    // Labels can be guest-supplied (party notes); match the sanitizing the dropdown row's [innerHTML] gets.
    tooltipEl.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.text) ?? '';

    this.tooltipEl = document.getElementsByTagName('html')[0].appendChild(tooltipEl);
    this.parentEl.addEventListener('mouseover', this.show);
    this.parentEl.addEventListener('mouseout', this.hide);
  }

  ngOnDestroy() {
    this.hide();

    if (this.tooltipEl) {
      document.getElementsByTagName('html')[0].removeChild(this.tooltipEl);
    }

    if (!this.parentEl) {
      return;
    }

    this.parentEl.removeEventListener('mouseover', this.show);
    this.parentEl.removeEventListener('mouseout', this.hide);
  }
}
